<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import BrandMark from '@/components/layout/BrandMark.vue'
import LocaleSwitcher from '@/components/layout/LocaleSwitcher.vue'
import ThemeToggle from '@/components/layout/ThemeToggle.vue'
import AppIcon from '@/components/ui/AppIcon.vue'

const { t } = useI18n()
const route = useRoute()
const largeMark = computed(() => route.name === 'login')
const academyMark = computed(() => route.name === 'login' || route.name === 'register')
const showLandingLink = computed(() => route.name === 'login' || route.name === 'register')
</script>

<template>
  <div class="flex min-h-full flex-col bg-stone-50 dark:bg-neutral-900">
    <div
      class="h-1.5 bg-gradient-to-r from-brand-700 via-brand-500 to-accent-400"
      aria-hidden="true"
    />
    <RouterLink
      v-if="showLandingLink"
      to="/"
      class="fixed top-4 start-4 z-20 inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-sm font-medium text-gray-600 hover:bg-white hover:text-gray-900 dark:text-neutral-300 dark:hover:bg-neutral-800 dark:hover:text-white"
    >
      <AppIcon name="arrow-left" size="sm" />
      {{ t('auth.landingPage') }}
    </RouterLink>
    <div class="fixed top-4 end-4 z-20 flex items-center gap-1">
      <ThemeToggle />
      <LocaleSwitcher />
    </div>

    <main class="flex flex-1 items-center justify-center px-4 pb-16">
      <div class="w-full max-w-md">
        <div class="mb-8 flex justify-center">
          <BrandMark stacked :academy="academyMark" :large="largeMark" />
        </div>

        <div
          class="rounded-2xl bg-white p-6 shadow-md ring-1 ring-stone-200/90 sm:p-8 dark:bg-neutral-800 dark:ring-neutral-700"
        >
          <slot />
        </div>
      </div>
    </main>
  </div>
</template>
